var _circle, _circle2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoints(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.2534,
    cy: 37.2534,
    r: 36.2534,
    fill: "#2FC6DB",
    stroke: "white",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.8616,
    cy: 51.8616,
    r: 28.137,
    fill: "#B25FFF",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.4095 37.6972C51.5883 37.3098 52.1389 37.3098 52.3176 37.6972L56.0209 45.726C56.0938 45.8839 56.2434 45.9926 56.4161 46.0131L65.1963 47.0541C65.62 47.1044 65.7901 47.6281 65.4769 47.9177L58.9855 53.9208C58.8578 54.0389 58.8006 54.2148 58.8345 54.3854L60.5577 63.0575C60.6408 63.476 60.1953 63.7997 59.823 63.5913L52.1078 59.2726C51.9561 59.1877 51.7711 59.1877 51.6194 59.2726L43.9041 63.5913C43.5318 63.7997 43.0863 63.476 43.1695 63.0575L44.8926 54.3854C44.9265 54.2148 44.8694 54.0389 44.7417 53.9208L38.2503 47.9177C37.937 47.6281 38.1072 47.1044 38.5309 47.0541L47.3111 46.0131C47.4838 45.9926 47.6334 45.8839 47.7062 45.726L51.4095 37.6972Z",
    fill: "#F8FAFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoints);
export default __webpack_public_path__ + "static/media/Points.79384e88382861376cb82106e37cd50d.svg";
export { ForwardRef as ReactComponent };